import React from "react";
import { Link } from "react-router-dom";

const RecoveryForm = (props) => {

  return (
    <div>
      <div className="flex bg-vide-gray-soft flex-col justify-center items-center h-navbar">
        <div className="min-w-[400px]">
          <div>
            <h1 className="mb-8 text-4xl font-bold text-vide-black-text">
              Password Recovery
            </h1>
          </div>

          <div>
            <div className="mt-6 ">
              <form className="space-y-6">
                <div className="form-group">
                  <label htmlFor="email" className="form-label">
                    Email address
                  </label>
                  <input
                    id="email"
                    name="email"
                    type="email"
                    autoComplete="email"
                    required
                    className="form-input"
                  />
                </div>

                <div>
                  <div>
                    <p className="mb-4 text-xs text-center text-red-500">
                      Incorrect credentials, verify them and try again.
                    </p>
                  </div>
                  <button href="" className="btn-primary">
                    Send Recovery Link
                  </button>
                  <div className="text-md text-center mt-5">
                    <Link to="/auth/login" className="font-medium text-vide-purple hover:text-vide-purple">
                      Return to Login Page
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RecoveryForm;
